import * as React from "react";
import { InjectedIntlProps, injectIntl } from "react-intl";
import "./carbonatation-messages";

import { ICarbonatationMeasurementManualInput } from "../../store/projects/types";

import { Alert, Form, InputNumber, Modal, Spin } from "antd";
import { FormComponentProps } from "antd/lib/form/Form";

interface IOwnProps {
    measurement?: ICarbonatationMeasurementManualInput;
    visible: boolean;
    loading: boolean;
    handleOk: () => void;
    handleCancel: () => void;
    error?: string;
}

type AllProps = IOwnProps & FormComponentProps & InjectedIntlProps;

class AddCarbonatationMeasurementManualInput extends React.PureComponent<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    public render() {
        const {
            form: { getFieldDecorator },
            error,
            measurement
        } = this.props;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 8 }
            }
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0
                },
                sm: {
                    span: 24,
                    offset: 0
                }
            }
        };

        return (
            <Modal
                title={this.props.intl.formatMessage({
                    id: "carbonatation.addManual"
                })}
                visible={this.props.visible}
                onOk={this.props.handleOk}
                onCancel={this.props.handleCancel}
                okButtonProps={{ disabled: this.props.loading }}
                cancelButtonProps={{ disabled: this.props.loading }}
            >
                <Spin spinning={this.props.loading}>
                    <Form layout="horizontal" onKeyPress={this.onKeyPress.bind(this)}>
                        <Form.Item
                            {...formItemLayout}
                            label={this.props.intl.formatMessage({
                                id: "carbonatation.avg"
                            })}
                        >
                            {getFieldDecorator("average", {
                                initialValue: measurement ? measurement.average : undefined,
                                rules: [
                                    {
                                        required: true,
                                        message: this.props.intl.formatMessage({
                                            id: "carbonatation.avg.required"
                                        })
                                    }
                                ]
                            })(<InputNumber autoFocus />)}
                        </Form.Item>

                        <Form.Item
                            {...formItemLayout}
                            label={this.props.intl.formatMessage({
                                id: "carbonatation.sd"
                            })}
                        >
                            {getFieldDecorator("standardDeviation", {
                                initialValue: measurement ? measurement.standardDeviation : undefined,
                                rules: [
                                    {
                                        required: true,
                                        message: this.props.intl.formatMessage({
                                            id: "carbonatation.sd.required"
                                        })
                                    }
                                ]
                            })(<InputNumber />)}
                        </Form.Item>

                        <Form.Item {...tailFormItemLayout}>
                            {error && (
                                <Alert
                                    message={this.props.intl.formatMessage({
                                        id: "error"
                                    })}
                                    description={error}
                                    type="error"
                                    showIcon
                                />
                            )}
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
        );
    }

    onKeyPress(event: React.KeyboardEvent) {
        if (event.key === "Enter") {
            this.props.handleOk();
        }
    }
}

const addCarbonatationMeasurementManualInputWrapped = injectIntl(
    Form.create<AllProps>()(AddCarbonatationMeasurementManualInput)
);

export {
    addCarbonatationMeasurementManualInputWrapped as AddCarbonatationMeasurementManualInput,
    AllProps as AddCarbonatationMeasurementManualInputProps
};
